import styled from 'styled-components';
import { keyframes } from 'styled-components';

interface ProgressProps {
  $progress: number;
}

interface LevelDisplayProps {
  $displayMode: 'compact' | 'full';
}

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(5px); }
  10% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-5px); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const sparkle = keyframes`
  0% { transform: scale(0) rotate(0deg); opacity: 0; }
  50% { transform: scale(1.5) rotate(180deg); opacity: 1; }
  100% { transform: scale(0) rotate(360deg); opacity: 0; }
`;

export const PointsChangeIndicator = styled.span<{ $isPositive: boolean }>`
  position: absolute;
  margin-left: 10px;
  color: ${props => (props.$isPositive ? '#4CAF50' : '#F44336')};
  font-size: 0.9em;
  font-weight: bold;
  animation: ${fadeInOut} 2s ease-in-out forwards;
`;

export const LevelUpAnimation = styled.div`
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  color: linear-gradient(45deg, #ff9800, #ff5722);
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: bold;
  text-align: center;
  animation: ${pulse} 0.5s ease-in-out infinite;
  z-index: 10;

  &::before,
  &::before {
    left: -15px;
    animation-delay: 0.3s;
  }

  &::after {
    right: -15px;
    animation-delay: 0.6s;
  }
`;

// Update existing components to support animations

export const PointsLabel = styled.span`
  font-size: 1rem;
  margin-top: 0.3rem;
  color: #666;
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  min-width: 16.8rem;
  max-width: 23.5rem;

  @media (max-width: 1224px) {
    width: 23.5rem;
  }

  @media (max-width: 1023px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const LevelProgressContainer = styled.div<LevelDisplayProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${props =>
    props.$displayMode === 'compact' ? 'center' : 'flex-start'};
  margin-left: 1.11rem;
`;

export const LevelIcon = styled.img`
  width: 3.6rem;
`;

export const LevelTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  color: #323232;
  font-size: 1rem;
  margin: 0;
`;

export const LevelProgressBar = styled.div`
  margin: 0.3rem 0;
  height: 1rem;
  width: 100%;
  background-color: #e2e2e2;
  border-radius: 5.56rem;
`;

export const Fill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${props => props.$progress}%;
  background: linear-gradient(90deg, #ff9800, #ff6d00);
  border-radius: 2rem;
  position: relative;
`;
